import {TFieldName} from '../Constants/FieldName';
import formFields from '../Constants/formFields';

class FormState {
    public activeFieldIndex: number;

    constructor(activeFieldIndex: number = 0) {
        this.activeFieldIndex = Math.max(0, Math.min(formFields.length - 1, activeFieldIndex));
    }

    public get activeField(): TFieldName {
        return formFields[this.activeFieldIndex].name;
    }

    public get isUsernameActive(): boolean {
        return this.activeField === 'username';
    }

    public get isPasswordActive(): boolean {
        return this.activeField === 'password';
    }

    public get nextIndex(): number {
        return this.activeFieldIndex + 1;
    }

    public get prevIndex(): number {
        return this.activeFieldIndex - 1;
    }

    public get canSubmit(): boolean {
        return this.activeFieldIndex === formFields.length - 1;
    }

    public get canGoBack(): boolean {
        return this.activeFieldIndex > 0;
    }
}

export default FormState;
